export enum ActionExecutionLocation {
    AlwaysOnTarget = "AlwaysOnTarget",
    AlwaysOnServer = "AlwaysOnServer",
    TargetOrServer = "TargetOrServer",
}

export default ActionExecutionLocation;
